<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'payroll.vacation-ytds.startingBalances' | translate }}"
        [menuService]="payrollModuleMenuService"
    ></app-header>

    <div class="ui segment hr-not-set-up" *ngIf="!hasEmployeesOnPayroll">
        <img src="/assets/illustrations/sofa.png" />
        <p>{{ 'payroll.vacation-ytds.noEmployeesOnPayroll' | translate }}</p>
    </div>

    <ng-container *ngIf="hasEmployeesOnPayroll">
        <ui-banner
            *ngIf="isTimeOffYtdUpdatable && !dismissedYTDUpdatableWarning"
            variant="warning"
            class="margin-bottom-3"
            [closable]="true"
            (close)="dismissedYTDUpdatableWarning = true"
        >
            {{ 'payroll.vacation-ytds.ensureCorrectInput' | translate }}
        </ui-banner>
        <div class="ui segment" *ngIf="!isLoading" [class.fullscreen]="fullscreen">
            <app-segment-header title="{{ 'payroll.vacation-ytds.enterStartingBalances' | translate }}">
                <div class="buttons">
                    <ui-button (click)="onToggleFullscreen()" type="link">
                        <mat-icon *ngIf="fullscreen" svgIcon="collapse"> </mat-icon>
                        <mat-icon *ngIf="!fullscreen" svgIcon="expand"> </mat-icon>
                        <span *ngIf="fullscreen; else exitFullScreen">{{
                            'payroll.vacation-ytds.exitFullscreen' | translate
                        }}</span>
                        <ng-template #exitFullScreen>
                            <span>{{ 'payroll.vacation-ytds.openFullscreen' | translate }}</span>
                        </ng-template>
                    </ui-button>
                </div>
            </app-segment-header>
            <div class="ui divider"></div>

            <div class="second-title">
                <div class="subtitle" [innerHTML]="'payroll.vacation-ytds.inputBalancesHelpText' | translate"></div>
                <div class="saving-indicator">
                    {{
                        (saving ? 'payroll.vacation-ytds.saving' : 'payroll.vacation-ytds.allChangesSaved') | translate
                    }}
                </div>
            </div>

            <div class="hot-container" *ngIf="!isLoading">
                <hot-table
                    [afterChange]="afterChange"
                    [beforeChange]="beforeChange"
                    [beforePaste]="beforePaste"
                    [cells]="cells"
                    [data]="dataset"
                    [hotId]="hotId"
                    [numericFormat]="{ pattern: '$0,0.00' }"
                    [rowHeaderWidth]="rowHeaderWidth"
                    [rowHeaders]="rowHeaders"
                    [settings]="settings"
                    [wordWrap]="false"
                    [manualColumnResize]="[125]"
                    [stretchH]="'none'"
                    [disableVisualSelection]="!isTimeOffYtdUpdatable"
                >
                    <hot-column
                        *ngFor="let column of columns"
                        [title]="column.title"
                        [data]="column.data"
                        [editor]="numericEditor"
                        [type]="column.type"
                        [readOnly]="!isTimeOffYtdUpdatable"
                    >
                    </hot-column>
                </hot-table>
            </div>
        </div>
    </ng-container>
</div>
